import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';
import { getConfig } from '@edx/frontend-platform';

export const sendMessageTutor = async (message, unitId) => {
  let url = `${getConfig().LMS_BASE_URL}/blendxapi/ai/assistant/canvas/`;
  const { data } = await getAuthenticatedHttpClient().post(url, {
    message: message,
    unit_id: unitId,
  });
  return data;
};